/* global PDFViewerApplication */
/* global pdfjsLib */

import WebsiteBehaviors from "./index.js";
import Selection from "../selection.js";
import {findDoiInElement} from "../utils/doi.js";
import Citation from "../citation.js";

class PDF extends WebsiteBehaviors {
	identifier() {
		return "PDF";
	}

	static test(location: Location) {
		return true;
	}

	static isPDF() {
		return true;
	}

	shouldFrameTakeControl() {
		// Sometimes the PDF might be embedded in the page
		return true;
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'processOrgProxy' implicitly has an 'any... Remove this comment to see the full error message
	getPageUrl(processOrgProxy) {
		// For PDFs, record the real url rather than our browser extension version of the url.
		// If baseUrl is relative, maybe we're in a different instance of pdf.js (not our extension), so use the
		// current URL as context to build an absolute one.

		// @ts-expect-error TS(2304) FIXME: Cannot find name 'PDFViewerApplication'.
		const url = new URL(PDFViewerApplication.baseUrl, window?.document?.location.href).href;
		return processOrgProxy(url);
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'annotation' implicitly has an 'any' typ... Remove this comment to see the full error message
	alterNewHighlight(annotation) {
		if (typeof window !== "undefined" && typeof (window as any).pdfjsLib !== "undefined")
		// @ts-expect-error TS(2304) FIXME: Cannot find name 'pdfjsLib'.
			annotation.selection.pdfJsVersion = pdfjsLib.version;
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'selection' implicitly has an 'any' type... Remove this comment to see the full error message
	findHighlightBoundaries(selection, uuid) {
		const warnCantRender = function () {
			console.warn("Annotation can't be rendered. (" + uuid + ")");
			return null;
		};

		if (!selection?.startTreeStr)
			return warnCantRender(); // We don't understand other selection methods here

		let modified = false;
		let startData = Selection.GetCorrectNodeAndOffset(selection.startTreeStr, selection.startOffset, "start");
		if (!startData) {
			// Replace the last "div" for a "span" and see if we can find the element then.
			// See https://github.com/mozilla/pdf.js/pull/10197
			const partsStart = selection.startTreeStr.split("/");
			const partsEnd = selection.endTreeStr.split("/");
			if (partsStart.length > 0
				&& partsEnd.length > 0
				&& partsStart[partsStart.length - 1].startsWith("div(")
				&& partsEnd[partsEnd.length - 1].startsWith("div(")
			) {
				partsStart[partsStart.length - 1] = partsStart[partsStart.length - 1].replace("div(", "span(");
				partsEnd[partsEnd.length - 1] = partsEnd[partsEnd.length - 1].replace("div(", "span(");

				selection = Object.assign({},
					selection,
					{
						startTreeStr: partsStart.join("/"),
						endTreeStr:   partsEnd.join("/")
					}
				);
				startData = Selection.GetCorrectNodeAndOffset(selection.startTreeStr, selection.startOffset, "start");
				modified = true;
			}
		}
		if (!startData)
			return warnCantRender();

		const endData = Selection.GetCorrectNodeAndOffset(selection.endTreeStr, selection.endOffset, "end");
		if (!endData)
			return warnCantRender();

		if (modified)
			console.warn("Annotation selection data had to be modified due to pdf.js issue (" + uuid + ")");

		if (Selection.GetNestedHighlight(selection, uuid)) {
			console.warn("Annotation NOT renderable due to overlap (" + uuid + ")");
			return null;
		}

		return {startData, endData};
	}

	/**
	 * Try to find a DOI in the text of the PDF, and use it for getting the citation data.
	 */
	async generateStructuredCitation() {
		// Limit the DOI search to 5 seconds in a PDF
		const searchTimeLimit = Date.now() + 5000;

		/**
		 * @ts-expect-error FIXME
		 */
		for (const element of Array.from(document.querySelectorAll("#viewer > .page > .textLayer") ?? [])) {
			// If the time limit has passed, stop searching
			if (searchTimeLimit - Date.now() < 0)
				return null;

			// @ts-expect-error FIXME
			const doi = findDoiInElement(element, searchTimeLimit);
			if (doi)
				return await Citation.fromDOI(doi);
		}
		return null;
	}
}

export default PDF;
